(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-osb-notify]:not([data-notify-ready])').forEach(section => {
      section.dataset.notifyReady = 'true';
      const form = section.querySelector('[data-osb-rsvp]');
      const name = form.querySelector('[name="name"]');
      const phone = form.querySelector('[name="phone"]');
      const button = form.querySelector('[type="submit"]');
      const note = section.querySelector('[data-osb-status-note]');
      const confirmation = section.querySelector('[data-osb-confirmation]');
      let busy = false;
      const cursor = section.querySelector('[data-osb-square-cursor]');
      if (cursor && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        section.addEventListener('pointermove', event => {
          cursor.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0) translate(-50%, -50%)`;
          cursor.classList.add('is-visible');
        }, { passive: true });
        section.addEventListener('pointerleave', () => cursor.classList.remove('is-visible'));
        window.addEventListener('blur', () => cursor.classList.remove('is-visible'));
      }
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy) return;
        note.textContent = '';
        confirmation.hidden = true;
        const cleanName = name.value.trim();
        const cleanPhone = phone.value.trim();
        const digits = cleanPhone.replace(/\D/g, '');
        if (!cleanName || !/^[+0-9().\s-]+$/.test(cleanPhone) || digits.length < 10 || digits.length > 15) {
          note.textContent = section.dataset.invalid;
          (!cleanName ? name : phone).focus();
          return;
        }
        busy = true;
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        try {
          if (!section.dataset.endpoint) throw new Error('Missing endpoint');
          const response = await fetch(section.dataset.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain;charset=utf-8' },
            body: JSON.stringify({ action: 'notify', name: cleanName, phone: cleanPhone, source: section.dataset.source, consent: 'back_up_text_v1' }),
            signal: AbortSignal.timeout(45000)
          });
          if (!response.ok) throw new Error('Request failed');
          const data = await response.json();
          if (!data.ok || data.mode !== 'notify_only' || data.status !== 'notified_later' || data.smsSent !== false || data.remindersScheduled !== false) throw new Error('Unexpected response');
          const message = data.duplicate ? section.dataset.duplicate : section.dataset.success;
          section.querySelector('[data-osb-confirmation-typed]').textContent = message;
          section.querySelector('[data-osb-confirmation-announcement]').textContent = message;
          confirmation.hidden = false;
        } catch (error) {
          note.textContent = section.dataset.error;
        } finally {
          busy = false;
          button.disabled = false;
          form.removeAttribute('aria-busy');
        }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
